import { render, staticRenderFns } from "./DataListVehicule_validate.vue?vue&type=template&id=21c87c2f&scoped=true&"
import script from "./DataListVehicule_validate.vue?vue&type=script&lang=js&"
export * from "./DataListVehicule_validate.vue?vue&type=script&lang=js&"
import style0 from "./DataListVehicule_validate.vue?vue&type=style&index=0&id=21c87c2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c87c2f",
  null
  
)

export default component.exports